export const JUMIO_IMAGE_CHECK_SUCCESS_EVENT = 'success';
export const JUMIO_IMAGE_CHECK_ERROR_EVENT = 'error';
export const JUMIO_POST_WINDOW_MESSAGE_NAME = 'message';
export const JUMIO_IDENTIFICATION_POLL_STATUS_INTERVAL = 15_000;
export const JUMIO_IDENTIFICATION_POLL_ALERT_SLOW_PROCESS_TIME = 60_000;
export const JUMIO_IDENTIFICATION_POLL_TIMEOUT = 600_000;
